var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.445 59.67V13.393H18.379V63.88l48.188-1.649",
    fill: "#FFD6C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.444 59.67V13.393H19.555v36.853",
    fill: "#FFD6C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.632 46.627l-41.718 9.17.996 13.187 38.12-5.09 4-.534 4.748-.634-6.146-16.099z",
    fill: "#FFA5A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.444 59.67V13.393H19.555v36.853",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.632 46.627l-41.718 9.17.996 13.187 38.12-5.09 4-.534 4.748-.634-6.146-16.099zM25.204 19.556H44M25.204 26.068H63.14M25.204 39.38H63.14M25.204 45.99h15.61M25.204 32.772H63.14M68.444 59.06a3.667 3.667 0 01-3.666 3.666",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgWill;